import { StringTransformRule } from "@utils/strings";

export const PRODUCT_PAGE_TITLE_RULES: Array<StringTransformRule> = [
  {
    validate: (productName) => productName.length > 70,
    transform: (productName) => productName.slice(0, 70).trim(),
  },
  {
    validate: (productName) => productName.length <= 58,
    transform: (productName) =>
      productName ? `${productName} | The Volte` : "The Volte",
  },
];
